import { getEnvironment } from "./api/environment";

export const LogLevel = {
	DEBUG: 0,
	INFO: 1,
	WARN: 2,
	ERROR: 3,
} as const;
export type LogLevel = (typeof LogLevel)[keyof typeof LogLevel];

export class FrameLogger {
	constructor(private readonly logLevel: LogLevel) {}

	private shouldLog(level: LogLevel): boolean {
		return level >= this.logLevel;
	}

	debug(...args: unknown[]) {
		const timestamp = new Date().toISOString();
		if (this.shouldLog(LogLevel.DEBUG)) {
			console.log(`[${timestamp}]`, ...args);
		}
	}

	info(...args: unknown[]) {
		const timestamp = new Date().toISOString();
		if (this.shouldLog(LogLevel.INFO)) {
			console.info(`[${timestamp}]`, ...args);
		}
	}

	warn(...args: unknown[]) {
		const timestamp = new Date().toISOString();
		if (this.shouldLog(LogLevel.WARN)) {
			console.warn(`[${timestamp}]`, ...args);
		}
	}

	error(...args: unknown[]) {
		const timestamp = new Date().toISOString();
		if (this.shouldLog(LogLevel.ERROR)) {
			console.error(`[${timestamp}]`, ...args);
		}
	}
}

export function getEnvironmentLogLevel(): LogLevel {
	const env = getEnvironment();

	switch (env) {
		case "development":
			return LogLevel.DEBUG; // Show all log levels
		case "staging":
			return LogLevel.DEBUG; // Show all log levels
		case "production":
			return LogLevel.INFO; // Show info, warn, error
		default:
			return LogLevel.INFO; // Default to info level
	}
}

export function createEnvironmentLogger(): FrameLogger {
	return new FrameLogger(getEnvironmentLogLevel());
}
